import React, { useContext, useState, useRef, useEffect, cache } from "react";
import ModuleSidebar from "../../components/ModuleSidebar/ModuleSidebar";
import { useLanguage } from "../../LanguageProvider";
import "./Kronos.css";
import { TbStack2 } from "react-icons/tb";
import InputField from "../../components/InputField/InputField";
import KronosBox from "./components/KronosBox/KronosBox";
import { GeneralContext } from "../../GeneralProvider";
import AddEditManualModal from "./components/AddEditManualModal/AddEditManualModal";
import EditStartModal from "./components/EditStartModal.js/EditStartModal";
import AlertBox from "../../components/AlertBox/AlertBox";
import AddGroupModal from "./components/AddGroupModal/AddGroupModal";
import Dropdown from "../../components/Dropdown/Dropdown";
import { useToaster } from "../../ToasterProvider";
import RangeSelector from "./components/RangeSelector/RangeSelector";

export default function Kronos({ openModal }) {
  const { toastWarning } = useToaster();
  const { getTranslation } = useLanguage();
  const {
    userId,
    handleKronosCreateAndStart,
    handleKronosStop,
    selectedProjectID,
    handleKronosGetByToken,
    handleKronosDiscard,
    handleKronosDelete,
    handleKronosUpdate,
    handleGetCurrentKronos,
    handleManualKronosCreate,
    handleCreateKronosGroup,
    handleUpdateKronosGroup,
    handleKronosStart,
    handleKronosLogDelete,
    getCollaboratorsByProjectID,
    getCollaboratorsKronoses,
    getUserAuthorizations,
    kronosRefreshCounter,
    activeKronos,
    subProjects
  } = useContext(GeneralContext);
  const [selectedSubmenu, setSelectedSubmenu] = useState(null);
  const [title, setTitle] = useState("");
  const [activeKronosData, setActiveKronosData] = useState(null);
  const [elapsedTime, setElapsedTime] = useState(0);
  const intervalRef = useRef(null);
  const [groups, setGroups] = useState([]);
  const [ungroup, setUngroup] = useState([]);
  const [totalDuration, setTotalDuration] = useState(0);
  const [isAddEditManualModalOpen, setAddEditManualModalOpen] = useState(false);
  const [isEditStartModalOpen, setIsEditStartModalOpen] = useState(false);
  const [modalType, setModalType] = useState("add");
  const [kronosToUpdate, setKronosToUpdate] = useState(null);
  const [differentKronos, setDifferentKronos] = useState(null);
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [filteredTimeLogs, setFilteredTimeLogs] = useState([]);
  const [menus, setMenus] = useState([]);
  const [isAddGroupModal, setIsAddGroupModal] = useState(false);
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [isAll, setIsAll] = useState(true);
  const [selectedDropdownGroup, setSelectedDropdownGroup] = useState(null);
  const [collaborators, setCollaborators] = useState([]);
  const [collaboratorsKronosList, setCollaboratorsKronosList] = useState([]);

  const [selectedRange, setSelectedRange] = useState("last7Days");
  const [selectedStartDate, setSelectedStartDate] = useState("");
  const [selectedEndDate, setSelectedEndDate] = useState("");
  const [projectAuthorization, setProjectAuthorization] = useState(null);
  const [selectedSubProject, setSelectedSubProject] = useState("");

  const [selectedCollaboratorRange, setSelectedCollaboratorRange] =
    useState("last7Days");
  const [selectedCollaboratorStartDate, setSelectedCollaboratorStartDate] =
    useState("");
  const [selectedCollaboratorEndDate, setSelectedCollaboratorEndDate] =
    useState("");
  const [totalSpesificDuration, setTotalSpesificDuration] = useState(0);

  const handleCloseAddManualModal = () => setAddEditManualModalOpen(false);

  const subProjectDropdownOptions = [
    { value: "", label: getTranslation("none") },
    ...(subProjects && Array.isArray(subProjects) ? subProjects : []),
  ];

  const handleSubmitAddManual = (formData) => {
    handleManualKronosCreate(
      formData.title,
      formData.startDateTime,
      formData.endDateTime,
      formData.groupId,
      formData.subProjectId
    );

    fetchKronoses(); // Verileri yenile
    handleCloseAddManualModal();
  };

  function extractUserIDs(dataArray) {
    return dataArray.map((item) => item.userID);
  }

  const fetchAuthorizations = async () => {
    const res = await getUserAuthorizations();

    if (res?.result?.length > 0) {
      const matchedProject = res?.result?.find(
        (item) => item.projectID === selectedProjectID
      );

      if (matchedProject) {
        setProjectAuthorization(matchedProject.authorizations);
      } else {
        setProjectAuthorization(null);
      }
    }
  };

  useEffect(() => {
    getCollaborators();
    fetchAuthorizations();
  }, [selectedProjectID]);

  useEffect(() => {
    fetchKronoses();
  }, [kronosRefreshCounter]);

  const getCollaborators = async () => {
    try {
      const response = await getCollaboratorsByProjectID();
      let collaboratorsWithoutMe = response.result.filter(
        (user) => user.userID !== userId
      );
      setCollaborators(collaboratorsWithoutMe);
      getCollaboratorsKronosList(extractUserIDs(collaboratorsWithoutMe));
    } catch (err) {
      console.log(err);
    }
  };

  const getCollaboratorsKronosList = async (
    collaborators,
    type = "last7Days"
  ) => {
    let rangeData;

    if (type === "inBetween") {
      rangeData = {
        type: type,
        start: selectedCollaboratorStartDate,
        end: selectedCollaboratorEndDate,
      };
    } else {
      rangeData = {
        type: type,
      };
    }
    try {
      const response = await getCollaboratorsKronoses(collaborators, rangeData);
      setCollaboratorsKronosList(response.result);
    } catch (err) {
      console.log(err);
    }
  };

  const addNewGroup = async (title) => {
    try {
      const response = await handleCreateKronosGroup(title);
      if (response.status) {
        fetchKronoses();
      }
    } catch (err) {
      // console.log(err);
    }
    setIsAddGroupModal(false);
  };

  const handleCreateStartKronos = async (bypassCheck = false) => {

    if (!bypassCheck && differentKronos) {
      setIsAlertOpen(true);
      return;
    }
    const log = {
      title: title,
      members: [{ id: userId, permission: "write" }],
      taskId: "",
      subProjectId: selectedSubProject ? selectedSubProject : ""
    };

    if (!title?.trim()) {
      toastWarning("kronosTitleCantBeEmpty");
      return;
    }
    try {
      const result = await handleKronosCreateAndStart(log);
      if (result.status) {
        setActiveKronosData({
          kronosId: result.result.kronosId,
          logId: result.result.logId,
          timestamp: result.timestamp,
          status: result.status,
          taskId: activeKronos?.taskId ? activeKronos.taskId : ""
        });
        setElapsedTime(0);
        startTimer();
      } else {
        console.error("Failed to start Kronos.");
      }
    } catch (error) {
      console.error("Error in KronosCreateAndStart:", error);
    }
  };

  const handleStopKronos = async () => {
    try {
      const result = await handleKronosStop(activeKronosData.logId);
      if (result?.status) {
        if (selectedDropdownGroup) {
          // Seçilen gruptaki kronosların kronosId'lerini al
          const selectedGroup = groups.find(
            (group) => group.groupId === selectedDropdownGroup
          );
          const groupKronosIds =
            selectedGroup?.kronoses.map((kronos) => kronos.kronosId) || [];

          // Aktif kronosId'yi mevcut listeye ekle
          const updatedKronosIds = [
            ...groupKronosIds,
            activeKronosData.kronosId,
          ];

          // Grubu güncelle
          await handleUpdateKronosGroup(
            selectedDropdownGroup,
            updatedKronosIds
          );
        }

        setActiveKronosData(null);
        stopTimer();
        fetchKronoses(); // Verileri yenile
      }
    } catch (error) {
      console.error("Error in handleStopKronos:", error);
    }
  };

  const handlePlayKronos = async (kronosId, kronosTitle) => {
    try {
      // Mevcut Kronos kontrolü
      const currentKronos = await handleGetCurrentKronos();
      if (currentKronos?.status && currentKronos.result?.logId) {
        const stopResult = await handleKronosStop(currentKronos.result.logId);
        if (!stopResult?.status) {
          fetchKronoses();
          console.error("Mevcut Kronos durdurulamadı.");
          return;
        }
      }

      // Yeni Kronos'u başlat
      const result = await handleKronosStart(kronosId, kronosTitle);

      if (result?.status) {
        setActiveKronosData({
          kronosId: result.result.kronosId,
          logId: result.result.logId,
          timestamp: result.timestamp,
          status: result.status,
        });

        setTitle(kronosTitle); // Başlık ayarla
        setElapsedTime(0); // Süreyi sıfırla
        startTimer(); // Timer'ı başlat
      } else {
        console.error("Yeni Kronos başlatılamadı.");
      }
    } catch (error) {
      console.error("Kronos başlatılırken hata oluştu:", error);
    }
  };

  const handleMoveToGroup = async (groupId, kronosId) => {
    try {
      // Mevcut grubu bul
      const currentGroup = groups.find((group) =>
        group.kronoses.some((kronos) => kronos.kronosId === kronosId)
      );

      let updatedGroups = [...groups];

      if (currentGroup) {
        // Mevcut gruptan kronosId'yi çıkar
        updatedGroups = updatedGroups.map((group) =>
          group.groupId === currentGroup.groupId
            ? {
              ...group,
              kronoses: group.kronoses.filter((k) => k.kronosId !== kronosId),
            }
            : group
        );

        // Sunucuya mevcut grubun güncellenmiş listesini gönder
        await handleUpdateKronosGroup(
          currentGroup.groupId,
          updatedGroups
            .find((g) => g.groupId === currentGroup.groupId)
            ?.kronoses.map((k) => k.kronosId) || []
        );
      }

      if (groupId !== "empty") {
        // Yeni gruba ekleme yap
        updatedGroups = updatedGroups.map((group) =>
          group.groupId === groupId
            ? { ...group, kronoses: [...group.kronoses, { kronosId }] }
            : group
        );

        // Sunucuya yeni grubun güncellenmiş listesini gönder
        await handleUpdateKronosGroup(
          groupId,
          updatedGroups
            .find((g) => g.groupId === groupId)
            ?.kronoses.map((k) => k.kronosId) || []
        );
      }

      fetchKronoses(); // Verileri yenile
    } catch (err) {
      console.error("Hata:", err);
    }
  };

  const handleDiscardKronos = async () => {
    try {
      const result = await handleKronosDiscard(
        activeKronosData.kronosId,
        activeKronosData.logId
      );
      if (result?.status) {
        setActiveKronosData(null);
        stopTimer();
      }
    } catch (error) {
      console.error("Error in handleDiscardKronos:", error);
    }
  };

  const cancelPreviousAndStart = async () => {
    try {
      const result = await handleKronosDiscard(
        differentKronos?.kronosId,
        differentKronos?.logId
      );
      if (result?.status) {
        handleCreateStartKronos(true);
        setDifferentKronos(null);
        setIsAlertOpen(false);
      }
    } catch (error) {
      console.error("Error in savePreviousAndStart:", error);
    }
  };

  const savePreviousAndStart = async () => {
    try {
      const result = await handleKronosStop(differentKronos?.logId);
      if (result?.status) {
        handleCreateStartKronos(true);
        setDifferentKronos(null);
        setIsAlertOpen(false);
      }
    } catch (error) {
      console.error("Error in savePreviousAndStart:", error);
    }
  };

  const handleDeleteLog = async (logIds) => {
    try {
      const result = await handleKronosLogDelete([logIds]);
      if (result?.status) {
        fetchKronoses();
      }
    } catch (error) {
      console.error("Error in handleKronosDelete:", error);
    }
  };

  const handleEditKronos = (kronos) => {
    setKronosToUpdate(kronos);
    setModalType("edit");
    setAddEditManualModalOpen(true);
  };

  const handleOpenAddManualModal = () => {
    setKronosToUpdate(null);
    setModalType("add");
    setAddEditManualModalOpen(true);
  };

  const handleTitleUpdate = async () => {
    if (!title.trim() || !activeKronosData) return;

    try {
      const updateData = {
        title: title.trim(),
      };

      await handleKronosUpdate(
        activeKronosData.kronosId,
        activeKronosData.logId,
        updateData
      );

      fetchKronoses();
    } catch (error) {
      console.error("Başlık güncelleme hatası:", error);
      // toastError(getTranslation("somethingWentWrong"));
    }
  };

  const handleSaveStartDateTime = async (startDateTime) => {
    try {
      const updateData = {
        startDateTime: startDateTime,
      };

      await handleKronosUpdate(
        activeKronosData.kronosId,
        activeKronosData.logId,
        updateData
      );
      fetchKronoses();
    } catch (error) {
      console.error("Error in handleSaveStartDateTime:", error);
      // toastError(getTranslation("somethingWentWrong"));
    }
  };

  const handleUpdateKronos = async (formData) => {
    const updateData = {
      title: formData.title,
      startDateTime: formData.startDateTime,
      endDateTime: formData.endDateTime,
      subProjectId: formData.subProjectId
    };

    try {
      // Önce temel kronos verisini güncelle
      await handleKronosUpdate(
        kronosToUpdate.kronosId,
        kronosToUpdate.logId,
        updateData
      );

      // Önceki groupId ile modal'dan gelen groupId'yi karşılaştıralım
      const previousGroupId = kronosToUpdate?.groupId; // Mevcutta varsa
      const newGroupId = formData.groupId; // Modal'dan gelen

      if (previousGroupId === newGroupId) {
        // Grup değişmemiş, ekstra işlem yapmaya gerek yok
      } else if (!newGroupId) {
        // Yeni groupId null ise, mevcut grup ilişkilendirmesini kaldır (removeGroup)
        await handleMoveToGroup("empty", kronosToUpdate.kronosId);
      } else {
        // Farklı bir id geldiyse, taşıma işlemini yap (move to new group)
        await handleMoveToGroup(newGroupId, kronosToUpdate.kronosId);
      }

      fetchKronoses();
    } catch (error) {
      console.error("Error in handleUpdateKronos:", error);
    }
  };

  const startTimer = () => {
    if (!intervalRef.current) {
      intervalRef.current = setInterval(() => {
        setElapsedTime((prev) => prev + 1);
      }, 1000);
    }
  };

  const stopTimer = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      setElapsedTime(0);
      setTitle("");
      intervalRef.current = null;
    }
  };

  useEffect(() => {
    if (!activeKronos) {
      setActiveKronosData(null);
      stopTimer();
      fetchKronoses();
    }
  }, [activeKronos]);

  const formatTime = (seconds) => {
    const hours = String(Math.floor(seconds / 3600)).padStart(2, "0");
    const minutes = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
    const secs = String(seconds % 60).padStart(2, "0");
    return `${hours}:${minutes}:${secs}`;
  };

  const calculateTotalDuration = (logs) => { 

    if (!Array.isArray(logs)) {
      console.error("calculateTotalDuration: logs bir dizi değil!", logs);
      return 0;
    }

    const totalSeconds = logs.reduce((total, timeLog) => {
      if (!timeLog || timeLog.startDateTime == null || timeLog.endDateTime == null) {
        console.warn("calculateTotalDuration: timeLog startDateTime veya endDateTime eksik. timeLog:", timeLog);
        return total;
      }

      const start = parseInt(timeLog.startDateTime, 10);
      const end = parseInt(timeLog.endDateTime, 10);

      if (isNaN(start) || isNaN(end)) {
        console.warn("calculateTotalDuration: Geçersiz tarih değeri. start:", timeLog.startDateTime, "end:", timeLog.endDateTime);
        return total;
      }

      return total + (end - start);
    }, 0);

    return totalSeconds;
  };

  const fetchKronoses = async (
    type = selectedRange === "today" ? "inBetween" : "last7Days"
  ) => {
    try {
      const currentKronos = await handleGetCurrentKronos();
      const currentKronosId = currentKronos?.status
        ? currentKronos.result.kronosId
        : null;

      if (currentKronos?.status) {
        const {
          kronosTitle,
          startDateTime,
          kronosId,
          logId,
          projectId,
          projectTitle,
        } = currentKronos.result;

        if (projectId !== selectedProjectID) {
          setDifferentKronos({
            kronosId,
            logId,
            kronosTitle,
            projectId,
            projectTitle,
          });
          setActiveKronosData(null);
          stopTimer();
        } else {
          const now = Math.floor(Date.now() / 1000);
          const elapsedTimeInSeconds = now - startDateTime;
          setActiveKronosData({
            kronosId,
            logId,
            startDateTime,
            title: kronosTitle,
            taskId: activeKronos?.taskId ? activeKronos.taskId : ""
          });
          setTitle(kronosTitle);
          setElapsedTime(elapsedTimeInSeconds);
          startTimer();
          setDifferentKronos(null);
        }
      } else {
        setActiveKronosData(null);
        setDifferentKronos(null);
      }

      let rangeData;
      if (type === "inBetween") {
        rangeData = {
          type: type,
          start: selectedStartDate,
          end: selectedEndDate,
        };
      } else {
        rangeData = { type };
      }


      const response = await handleKronosGetByToken(rangeData);
      if (response.status) {
        const ungroupLogs = (response.result.ungroup || []).map((log) => ({
          ...log,
          groupId: null,
        }));

        const groupLogs = (response.result.groups || []).flatMap((group) =>
          (group.kronoses || []).map((kronos) => ({
            ...kronos,
            groupId: group.groupId,
          }))
        );

        const allLogs = [...ungroupLogs, ...groupLogs];

        const groupMenus = (response.result.groups || []).map((group) => ({
          title: group.title,
          id: group.groupId,
          icon: <TbStack2 size={20} />,
        }));

        const groupDropdownOptions = [
          { value: "empty", label: getTranslation("noGroup") },
          ...(response.result.groups || []).map((group) => ({
            value: group.groupId,
            label: group.title,
          })),
        ];

        setUngroup(response.result.ungroup || []);
        setGroups(response.result.groups || []);
        setMenus(groupMenus);
        setDropdownOptions(groupDropdownOptions);

        if (selectedDropdownGroup && !isAll) {
          const selectedGroup = (response.result.groups || []).find(
            (group) => group.groupId === selectedDropdownGroup
          );
          const filteredLogs = (selectedGroup?.kronoses || [])
            .filter((log) => log.kronosId !== currentKronosId)
            .map((log) => ({ ...log, groupId: selectedGroup.groupId }));

          let allTimeLogs = filteredLogs.flatMap((log) =>
            log.timeLogs.map((timeLog) => ({
              ...timeLog,
              title: log.title,
              kronosId: log.kronosId,
              groupId: log.groupId,
              taskId: log.taskId,
              subProjectTitle: log?.subProject?.title,
              subProjectId: log?.subProject?.subProjectId
            }))
          );
          // Sıralama: En yeni (büyük startDateTime) en üstte
          allTimeLogs.sort(
            (a, b) =>
              parseInt(b.startDateTime, 10) - parseInt(a.startDateTime, 10)
          );

          setFilteredTimeLogs(allTimeLogs);
          const totalDuration = calculateTotalDuration(filteredLogs);
          setTotalDuration(totalDuration);
        } else {
          const filteredLogs = allLogs.filter(
            (log) => log.kronosId !== currentKronosId
          );
          let allTimeLogs = allLogs.flatMap((log) =>
            log.timeLogs.map((timeLog) => ({
              ...timeLog,
              title: log.title,
              kronosId: log.kronosId,
              groupId: log.groupId,
              taskId: log.taskId,
              subProjectTitle: log?.subProject?.title,
              subProjectId: log?.subProject?.subProjectId
            }))
          );
          // Sıralama: En yeni en üstte
          allTimeLogs.sort(
            (a, b) =>
              parseInt(b.startDateTime, 10) - parseInt(a.startDateTime, 10)
          );

          setFilteredTimeLogs(allTimeLogs);
          const totalDuration = calculateTotalDuration(allTimeLogs);
          setTotalDuration(totalDuration);
        }
      }
    } catch (error) {
      console.error("Kronos verisi çekilemedi:", error);
    }
  };

  useEffect(() => {
    return () => {
      stopTimer();
    };
  }, []);

  useEffect(() => {
    if (selectedSubmenu && collaboratorsKronosList?.length > 0) {
      const selectedCollaborator = collaboratorsKronosList?.find(
        (item) => item.kronosCreatedBy === selectedSubmenu
      );

      if (selectedCollaborator) {
        // O kişinin kronoslarını ve timeLogs'larını al
        const selectedKronoses = selectedCollaborator.kronoses || [];

        // Seçili collaborator'ın toplam süresini hesapla
        const totalDuration = selectedKronoses.reduce((total, kronos) => {
          return (
            total +
            kronos.timeLogs.reduce((logTotal, timeLog) => {
              const start = parseInt(timeLog.startDateTime, 10);
              const end = parseInt(timeLog.endDateTime, 10);
              return logTotal + (end - start);
            }, 0)
          );
        }, 0);

        setTotalSpesificDuration(totalDuration);

        const allTimeLogs = selectedKronoses.flatMap((kronos) =>
          kronos.timeLogs.map((timeLog) => ({
            ...timeLog,
            title: kronos.title,
            kronosId: kronos.kronosId,
            taskId: kronos.taskId,
          }))
        );
        setFilteredTimeLogs(allTimeLogs);
      } else {
        setTotalSpesificDuration(0);
      }
    }
  }, [
    selectedCollaboratorStartDate,
    selectedCollaboratorEndDate,
    selectedCollaboratorRange,
    collaboratorsKronosList,
    selectedSubmenu,
  ]);

  useEffect(() => {
    fetchKronoses();
  }, [selectedProjectID]);

  useEffect(() => {
    if (selectedRange === "today" && selectedStartDate && selectedEndDate) {
      fetchKronoses("inBetween");
    }
  }, [selectedRange, selectedStartDate, selectedEndDate]);

  useEffect(() => {
    if (
      selectedCollaboratorRange === "today" &&
      selectedCollaboratorStartDate &&
      selectedCollaboratorEndDate
    ) {
      getCollaboratorsKronosList([selectedSubmenu], "inBetween");
    }
  }, [
    selectedCollaboratorRange,
    selectedCollaboratorStartDate,
    selectedCollaboratorEndDate,
  ]);

  const handleDropdownChange = (selectedOption) => {
    if (selectedOption === "empty") {
      setSelectedDropdownGroup(null);
    } else {
      setSelectedDropdownGroup(selectedOption);
    }
  };

  const handleSubmenuClick = (submenu) => {
    setSelectedSubmenu(submenu?.id);
    if (submenu?.type === "collaborator") {
      getCollaboratorsKronosList([submenu.id], selectedCollaboratorRange);
    } else {
      if (submenu?.id) {
        const selectedGroup = groups.find(
          (group) => group.groupId === submenu.id
        );
        // 1. Mevcut filtreleme (aktif olanı çıkar)
        const filteredKronosLogs =
          selectedGroup?.kronoses.filter(
            (log) => log.kronosId !== activeKronosData?.kronosId
          ) || [];

        // 2. YENİ: Kronos listesinden timeLog'ları düzleştir (flatten)
        let allTimeLogs = filteredKronosLogs.flatMap((log) =>
          log.timeLogs.map((timeLog) => ({
            ...timeLog,
            title: log.title,
            kronosId: log.kronosId,
            groupId: selectedGroup.groupId, // veya log.groupId zaten varsa
            taskId: log.taskId,
            subProjectTitle: log?.subProject?.title,
            subProjectId: log?.subProject?.subProjectId
          }))
        );

        // 3. Sıralama (isteğe bağlı, UI için)
        allTimeLogs.sort(
          (a, b) =>
            parseInt(b.startDateTime, 10) - parseInt(a.startDateTime, 10)
        );

        setFilteredTimeLogs(allTimeLogs); // UI için

        // 4. YENİ: calculateTotalDuration'a düzleştirilmiş timeLog listesini geçir
        const totalDuration = calculateTotalDuration(allTimeLogs); // <-- Düzeltildi
        setTotalDuration(totalDuration); // <-- Düzgün çalışıyor olacak

        setSelectedDropdownGroup(submenu.id);
        setIsAll(false);
      } else {
        const allLogs = [
          ...ungroup.map((log) => ({ ...log, groupId: null })),
          ...groups.flatMap((group) =>
            (group.kronoses || []).map((log) => ({
              ...log,
              groupId: group.groupId,
            }))
          ),
        ];

        let allTimeLogs = allLogs.flatMap((log) =>
          log.timeLogs.map((timeLog) => ({
            ...timeLog,
            title: log.title,
            kronosId: log.kronosId,
            groupId: log.groupId,
            taskId: log.taskId,
            subProjectTitle: log?.subProject?.title,
            subProjectId: log?.subProject?.subProjectId
          }))
        );
        allTimeLogs.sort(
          (a, b) =>
            parseInt(b.startDateTime, 10) - parseInt(a.startDateTime, 10)
        );

        setFilteredTimeLogs(allTimeLogs);
        const totalDuration = calculateTotalDuration(allTimeLogs);
        setTotalDuration(totalDuration);
        setSelectedDropdownGroup(null);
        setIsAll(true);
      }
    }
  };

  const buttons = [
    {
      text: getTranslation("savePreviousAndStart"),
      onClick: savePreviousAndStart,
      styleType: "alert-confirm",
    },
    {
      text: getTranslation("cancelPreviousAndStart"),
      onClick: cancelPreviousAndStart,
      styleType: "alert-confirm",
    },
    {
      text: getTranslation("close"),
      onClick: () => setIsAlertOpen(false),
      styleType: "alert-cancel",
    },
  ];

  return (
    <>
      <div className="kronos-container">
        <ModuleSidebar
          title={"Kronos List"}
          menus={[
            {
              sections: [
                {
                  title: getTranslation("groups"),
                  submenu: [
                    {
                      title: getTranslation("all"),
                      id: null,
                      icon: <TbStack2 size={20} />,
                      type: "group",
                    },
                    // Mevcut `menus` state'inizdeki grup menülerine type ekleyerek
                    ...menus.map((menuItem) => ({
                      ...menuItem,
                      type: "group",
                    })),
                  ],
                },
                ...(collaborators?.length > 0 &&
                  projectAuthorization?.canSeeKronos
                  ? [
                    {
                      title: getTranslation("collaborators"),
                      showEntityButton: false,
                      submenu: collaborators.map((collab) => ({
                        title: `${collab.name} ${collab.lastname}`,
                        id: collab.userID,
                        type: "collaborator",
                      })),
                    },
                  ]
                  : []),
              ],
            },
          ]}
          onSubmenuClick={(submenu) => handleSubmenuClick(submenu)}
          selectedSubmenu={selectedSubmenu}
          addEntitiy={() => setIsAddGroupModal(true)}
        />
        <div className="kronos-content">
          <div className="kronos-inner-content">
            {selectedSubmenu &&
              collaborators.find(
                (collab) => collab.userID === selectedSubmenu
              ) ? (
              <>
                <RangeSelector
                  selectedRange={selectedCollaboratorRange}
                  setSelectedRange={setSelectedCollaboratorRange}
                  selectedStartDate={selectedCollaboratorStartDate}
                  setSelectedStartDate={setSelectedCollaboratorStartDate}
                  selectedEndDate={selectedCollaboratorEndDate}
                  setSelectedEndDate={setSelectedCollaboratorEndDate}
                  fetchDatas={(e) =>
                    getCollaboratorsKronosList([selectedSubmenu], e)
                  }
                />
                <div className="kronos-header-section">
                  <span className="kronos-title">
                    {selectedCollaboratorRange === "today" &&
                      getTranslation("today")}
                    {selectedCollaboratorRange === "last7Days" &&
                      getTranslation("last7Days")}
                    {selectedCollaboratorRange === "last30Days" &&
                      getTranslation("last30Days")}
                    {selectedCollaboratorRange === "last365Days" &&
                      getTranslation("last365Days")}
                  </span>
                  <span className="kronos-total-time-label">
                    {getTranslation("totalDuration")}:{" "}
                    {formatTime(totalSpesificDuration)}
                  </span>
                </div>
                {(() => {
                  const selectedCollaborator = collaboratorsKronosList?.find(
                    (item) => item.kronosCreatedBy === selectedSubmenu
                  );
                  return selectedCollaborator && selectedCollaborator.kronoses
                    ? selectedCollaborator.kronoses.flatMap((kronos) =>
                      kronos.timeLogs.map((timeLog, index) => (
                        <KronosBox
                          type="view"
                          key={`${kronos.kronosId}-${index}`}
                          box={{
                            ...timeLog,
                            title: kronos.title,
                            kronosId: kronos.kronosId,
                          }}
                          index={index}
                          handleDelete={handleDeleteLog}
                          handleEdit={handleEditKronos}
                          handlePlay={handlePlayKronos}
                          groups={dropdownOptions}
                          moveToGroup={handleMoveToGroup}
                          activeKronos={activeKronos}
                        />
                      ))
                    )
                    : null;
                })()}
              </>
            ) : (
              // Aksi halde normal inner content'i gösteriyoruz.
              <>
                <div className="kronos-header-section">
                  <span className="kronos-title">
                    {getTranslation("setTimer")}
                  </span>
                  <button
                    onClick={handleOpenAddManualModal}
                    className="kronos-add-manual-button"
                  >
                    {getTranslation("addManual")}
                  </button>
                </div>
                <div className="kronos-timer-section">
                  <InputField
                    placeholder={getTranslation("whatAreYouWorkingOn")}
                    type="text"
                    onChange={(e) => setTitle(e.target.value)}
                    value={title}
                    style={{ height: "42px" }}
                    onBlur={() => activeKronosData && handleTitleUpdate()}
                  />
                  {groups?.length > 0 &&
                    (isAll || selectedDropdownGroup === null) && (
                      <Dropdown
                        placeholder={getTranslation("selectGroup")}
                        style={{ width: "300px", marginLeft: "6px" }}
                        options={dropdownOptions}
                        onChange={(e) => handleDropdownChange(e.target.value)}
                        value={selectedDropdownGroup}
                      />
                    )}

                  {subProjects?.length > 0 &&
                    <Dropdown
                      placeholder={getTranslation("selectProject")}
                      style={{ width: "300px", marginLeft: "6px" }}
                      options={subProjectDropdownOptions}
                      onChange={(e) =>
                        setSelectedSubProject(e.target.value)
                      }
                      value={selectedSubProject}
                    />
                  }

                  <span
                    className="kronos-timer-clock"
                    onClick={() => {
                      activeKronosData && setIsEditStartModalOpen(true);
                    }}
                  >
                    {formatTime(elapsedTime)}
                  </span>
                  {!activeKronosData ? (
                    <button
                      disabled={!title}
                      onClick={() => handleCreateStartKronos(false)}
                      className="kronos-start-button"
                    >
                      {getTranslation("start")}
                    </button>
                  ) : (
                    <>
                      <button
                        onClick={handleStopKronos}
                        className="kronos-start-button"
                      >
                        {getTranslation("stop")}
                      </button>
                      <button
                        onClick={handleDiscardKronos}
                        className="kronos-start-button"
                      >
                        {getTranslation("discard")}
                      </button>
                    </>
                  )}
                </div>
                <RangeSelector
                  selectedRange={selectedRange}
                  setSelectedRange={setSelectedRange}
                  selectedStartDate={selectedStartDate}
                  setSelectedStartDate={setSelectedStartDate}
                  selectedEndDate={selectedEndDate}
                  setSelectedEndDate={setSelectedEndDate}
                  fetchDatas={fetchKronoses}
                />
                <div className="kronos-header-section">
                  <span className="kronos-title">
                    {selectedRange === "today" && getTranslation("today")}
                    {selectedRange === "last7Days" &&
                      getTranslation("last7Days")}
                    {selectedRange === "last30Days" &&
                      getTranslation("last30Days")}
                    {selectedRange === "last365Days" &&
                      getTranslation("last365Days")}
                  </span>
                  <span className="kronos-total-time-label">
                    {getTranslation("totalDuration")}:{" "}
                    {formatTime(totalDuration)}
                  </span>
                </div>
                <div style={{ marginTop: "16px" }}>
                  {filteredTimeLogs?.map((box, index) => (
                    <KronosBox
                      key={index}
                      box={box}
                      index={index}
                      handleDelete={handleDeleteLog}
                      handleEdit={() => handleEditKronos(box)}
                      handlePlay={handlePlayKronos}
                      groups={dropdownOptions}
                      moveToGroup={handleMoveToGroup}
                      openModal={openModal}
                      activeKronos={activeKronos}
                    />
                  ))}
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      <AddEditManualModal
        isOpen={isAddEditManualModalOpen}
        type={modalType}
        onClose={handleCloseAddManualModal}
        onSubmit={handleSubmitAddManual}
        data={kronosToUpdate}
        onEdit={handleUpdateKronos}
        groups={dropdownOptions}
        selectedGroupAtKronos={selectedDropdownGroup}
        subProjects={subProjects}
      />
      <EditStartModal
        isOpen={isEditStartModalOpen}
        activeKronosData={activeKronosData}
        onClose={() => setIsEditStartModalOpen(false)}
        onSave={handleSaveStartDateTime}
      />

      <AlertBox
        isOpen={isAlertOpen}
        // title={getTranslation('activeKronosMessage')}
        message={getTranslation("activeKronosMessage", {
          projectTitle: differentKronos?.projectTitle,
          kronosTitle: differentKronos?.kronosTitle,
        })}
        buttons={buttons}
        type={"warning"}
      />

      <AddGroupModal
        isOpen={isAddGroupModal}
        onClose={() => setIsAddGroupModal(false)}
        onCreate={addNewGroup}
      />
    </>
  );
}
